import { RoleInfo } from './types';

export const roleInfos: RoleInfo[] = [
  { title: 'Все', roleKey: 'general' },
  { title: 'Админ/Разраб', roleKey: 'AD' },
  { title: 'Зритель/Аналитик', roleKey: 'AV' },
];
